module.exports = __webpack_public_path__ + "img/about_img3.25d0e018.png";